import React from 'react';
import { Button, Form, Input } from 'antd';
import { AddManagerFormWrapper } from './user.style';
import { useSave } from '../hooks/useSave';

export const AddManagerForm = (props: any) => {
  const { onVisibleChange, onSetReloadAfterDrawer } = props;
  const [form] = Form.useForm();
  const { onManagerSave } = useSave();

  return (
    <AddManagerFormWrapper>
      <Form form={form} name="nest-messages" layout="vertical" size="large">
        <Form.Item label="Full Name" name={'full_name'}>
          <Input />
        </Form.Item>
        <Form.Item label="Username" name={'username'}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name={'email'}
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Phone Number" name={'phone_number'}>
          <Input />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input.Password />
        </Form.Item>
        <Form.Item label="Remarks" name="remarks">
          <Input.TextArea />
        </Form.Item>
        <Form.Item>
          <Button
            htmlType="submit"
            onClick={() => {
              onManagerSave(
                { ...form.getFieldsValue() },
                form,
                onVisibleChange,
                onSetReloadAfterDrawer,
              );
            }}
          >
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddManagerFormWrapper>
  );
};

export default AddManagerForm;
